import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Privacy from 'components/privacy';

type Props = {
  data: Object,
};

const PrivacyPage = ({ data }: Props) => {
  const {
    privacyJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...privacyJson,
        menu: siteJson?.content,
        cookieConsent: cookieConsentJson,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <Privacy />
      </Layout>
    </Website>
  );
};

export default PrivacyPage;

export const query = graphql`
  query PrivacyPageQuery {
    privacyJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
        text
      }
      intro {
        title
        greece {
          title
          data {
            id
            label
            details
          }
        }
      }
      statements {
        tabs {
          id
          label
          title
          text
          list {
            items
          }
        }
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
